// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f72da1c8","703":"2d3b20da"}[chunkId] + ".chunk.js";
};